module.exports = __webpack_public_path__ + "img/banner.621f711d.png";